import classNames from 'classnames';
import setDenaliAttribute from '../../utils/setDenaliAttribute';
import styles from './styles/styles.module.scss';

type LoadingDotsProps = {
  className?: string;
};

const LoadingDots = ({ className }: LoadingDotsProps) => (
  <div {...setDenaliAttribute('LoadingDots')} className={classNames(styles.container, className)}>
    <div className={styles.dot1} />
    <div className={styles.dot2} />
    <div className={styles.dot3} />
  </div>
);

export default LoadingDots;
